import type { Block } from '@sarnia/shared';

export function listTopLevelBlockIds(blocks: Block[]): string[] {
  return blocks.map((block) => block.id);
}

export function getAdjacentBlockId(
  blocks: Block[],
  selectedBlockId: string | null,
  direction: 'previous' | 'next'
): string | null {
  if (blocks.length === 0) {
    return null;
  }

  const ids = listTopLevelBlockIds(blocks);
  const currentIndex = selectedBlockId ? ids.indexOf(selectedBlockId) : -1;

  if (currentIndex < 0) {
    return ids[0] ?? null;
  }

  const nextIndex = direction === 'previous' ? currentIndex - 1 : currentIndex + 1;
  return ids[nextIndex] ?? null;
}
